module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyt",
    attrs: {
      "id": "copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Copyright © 2015 by Ernesto Ortiz")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KASHIC")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECORDS")]), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITED BY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRSTEN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEY")]), _c('br'), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPESET BY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHENCK")]), _c('br'), _vm._v("Cover design by Howard Grossman/12E Design"), _c('br'), _vm._v("Diagrams on "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 48")]), _vm._v(" courtesy of SSRF."), _c('br'), _c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.spiritualresearchfoundation.org",
      "target": "_blank"
    }
  }, [_vm._v("www.spiritualresearchfoundation.org")])]), _vm._v("."), _c('br'), _vm._v("Sacred Prayer on pages 128-129 translated by Jim Duyer: "), _c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.event12.com",
      "target": "_blank"
    }
  }, [_vm._v("www.event12.com")])]), _vm._v("."), _c('br'), _vm._v("Printed in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Career Press, Inc."), _c('br'), _vm._v("220 West Parkway, Unit 12"), _c('br'), _vm._v("Pompton Plains, NJ 07444"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.careerpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.careerpress.com")]), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.newpagebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.newpagebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Ortiz, Ernesto.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("   The Akashic records : sacred exploration of your soul’s journey within the wisdom of the collective consciousness / Ernesto Ortiz.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("        pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("   Summary: “The Akashic Records is equal parts practical and profound, the culmination of nearly two decades of immersion by Ernesto, personally and professionally, into the Akashic Records for individual healing, growth, and self-realization”” Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("    Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("   ISBN 978-1-60163-345-3 (paperback) -ISBN 978-1-60163-439-9 (ebook) 1. Akashic records. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("   BF1045.A44O78 2014"), _c('br'), _vm._v("   133.9--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2014028053")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 63
// module chunks = 0